import React from 'react';
import {Button} from '../Button/Button';
import './TextButton.scss';

export class TextButton extends Button {

    static defaultProps = {
        className: 'button button-text button-ripple'
    };
}



// WEBPACK FOOTER //
// /Users/stephan/skelware/savot/src/components/TextButton/TextButton.jsx